export default class FetchError extends Error {
    public statusCode: number;
    public errorCode?: string;
    public innerError?: Error | string;

    constructor(statusCode: number, errorCode?: string, innerError?: Error | string) {
        super(`${statusCode} ${errorCode} ${innerError}`);
        this.name = 'ControllerError';
        this.stack = innerError && (innerError as any).stack ? (innerError as any).stack : (<any>new Error()).stack;
        this.statusCode = statusCode;
        this.errorCode = errorCode;
        this.innerError = innerError;
    }
}
